import { useEffect, useState } from "react";
import CircularProgress from "../CircularProgress";
import MarketHeroCard from "./MarketHeroCard";

const modalContentStyle = (error: boolean): React.CSSProperties => ({
  display: "flex",
  height: "100%",
  flexDirection: "column",
  background: !error ? "rgba(41, 155, 128, 1)": "rgba(207, 21, 88, 1)",
  width: "-webkit-fill-available",
  justifyContent: "left",
  alignItems: "left",
  alignContent: "left",
});

const topStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "center",
  height: "100%",
  color: "#FFFFFF",
  padding: 30,
  fontSize: "30px",
  gap: 30,
  zIndex: 0,
  overflow: "hidden",
};

const progressStyle = (progress: number): React.CSSProperties => {
  return {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    background: `radial-gradient(closest-side, white 79%, transparent 80% 0%),conic-gradient(rgba(255, 255, 255, 1) ${progress}%, rgba(255, 255, 255, 0.1) 0)`,
  };
};

const firstButton: React.CSSProperties = {
  flex: "0 0 auto",
  fontFamily: "GT Planar Medium",
  paddingTop: 4,
  cursor: "pointer",
  height: 48,
  background: "rgba(255, 255, 255, 1)",
  borderRadius: 12,
  border: "1px solid rgb(255,255,255,0.3)",
  color: "#000000",
  width: "100%",
};

const secondButton: React.CSSProperties = {
  flex: "0 0 auto",
  paddingTop: 4,
  cursor: "pointer",
  height: 48,
  background: "rgb(0,0,0,0)",
  borderRadius: 12,
  border: "1px solid rgb(255,255,255,0.3)",
  color: "#FFFFFF",
  width: "100%",
};

interface MarketMintPageProps {
  userInfo: any;
  domain: string;
  checkoutId: string;
  walletAddress: string;
  apiUrl: any;
  setHeight: (height: any) => void;
  close: () => void;
}

export const MarketMintPage: React.FC<MarketMintPageProps> = ({
  userInfo,
  domain,
  checkoutId,
  setHeight,
  apiUrl,
  close,
}) => {
  const size = 300;
  const [errorMessage, setErrorMessage] = useState<string>("")
  const [progress, setProgress] = useState<number>(0);
  const [paymentStatus, setPaymentStatus] = useState<string>("PENDING");

  const checkOrder = (orderId: string) => {
    return fetch(`${apiUrl}/v1/market/order/${orderId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
  }


  useEffect(() => {
    setHeight(600)
  },[])

  useEffect(() => {
    const intervalTime = paymentStatus == "SUCCESSFUL" ? 1: 60; // 60 milliseconds

    const interval = setInterval(() => {
      setProgress((prevCounter) => {
        if ((prevCounter < 2000 && prevCounter != 980 && paymentStatus == "PENDING") || (prevCounter < 1000 && paymentStatus == "SUCCESSFUL")) {
          return prevCounter + 1; // Increment by 1
        }
        setHeight(660)
        return prevCounter; // Return the current value if it's already 1000
      });
    }, intervalTime);

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(interval);
    };
  }, [paymentStatus]);

  useEffect(() => {
    const intervalTime = 5000;

    const interval = setInterval(() => {
      if(progress < 1000) {
        checkOrder(checkoutId).then((data: any) => {
          setPaymentStatus(data.orderStatus)
          if(data.orderStatus == "FAILED") {
            setErrorMessage(data.orderStatusReason)
          }
        }).catch((e) => {
          console.log(e)
        })
      }

    }, intervalTime);

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div style={modalContentStyle(errorMessage != "")}>
      <div style={topStyle}>
        {errorMessage == "" ? (progress != 1000 ? <div>Minting...</div> : <div>🎉 It's yours!</div>): null}
        {errorMessage != "" && progress != 1000 ? <div>Something went wrong</div> : null}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
            fontSize: "12px",
            fontFamily: "GT Planar Regular",
          }}
        >
          <div>
            <div style={{ position: "relative", zIndex: 1, height: 320 }}>
              
              {progress != 1000 && (
                <CircularProgress
                  percentage={progress / 10.0}
                  strokeWidth={8}
                  size={300}
                />
              )}

              <MarketHeroCard
                domain={domain}
                walletAddress={userInfo.walletAddress}
                avatarUrl={""}
                backgroundUrl="https://assets.superlink.me/backgrounds/58d9d9ef-313b-4e81-8908-cc23bb251bfa"
                containerStyle={{
                  opacity: errorMessage != "" ? 0.5: 1,
                  transform:
                    progress == 1000
                      ? `rotate(${
                          360 * (progress / 10.0 / 100) * 4
                        }deg) scale(1)`
                      : `rotate(${
                          360 * (progress / 10.0 / 100) * 4
                        }deg) scale(0.5)`,
                  transition: progress != 1000 ? "transform 150ms ease": "transform 1000ms ease",
                  left: progress == 1000 ? -(size / 2): 0,
                  top: progress == 1000 ? -(size / 2) + 160 : -(size / 2) + 150,
                  width: size,
                  height: size,
                  boxShadow:
                    "0px -25px 20px -20px rgba(0,0,0,0.45),25px 0px 20px -20px rgba(0,0,0,0.45),0px 25px 20px -20px rgba(0,0,0,0.45),-25px 0px 20px -20px rgba(0,0,0,0.45)",
                }}
              />
            </div>
          </div>
        </div>

        <div style={{
          fontFamily: 'GT Planar Regular',
          fontSize: "16px",
          textAlign: 'center',
          color: "rgba(255, 255, 255, 0.8)"
        }}>
        {errorMessage != "" ? errorMessage : "You can wait here or we’ll send you an email when minting is complete"}
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: "100%",
          gap: 8
        }}>
        {progress == 1000 && <button onClick={close} style={firstButton}>
          Use it now
        </button>}
        <button onClick={close} style={secondButton}>
          Get another one
        </button>    
        </div>

      </div>
    </div>
  );
};
